import { KEY_LOCAL_TYPE_USER, TYPE_USER } from '../../../helper/const';
import { GET_BANNER_HOME, GET_BID_PRODUCT, GET_TOTAL_USER_BID, GET_UP_NEXT_PRODUCT, SET_ADVER_TISEMENT, SET_SHWE_HOURS_ICON, TYPE_INTRO_TOUR } from './contants'

const initState = {
	bidProduct: [],
	upNextProduct: [],
	banner: [],
	totalUserBid: 0,
	typeIntroTour: {
		typeActive: localStorage.getItem(KEY_LOCAL_TYPE_USER) ? parseInt(localStorage.getItem(KEY_LOCAL_TYPE_USER)) : TYPE_USER.general,
		step: 0,
	},
  shweHoursIconData: null,
  isClosePopupAdvertisement: false,
}
const reducerHome = (state = initState, actions) => {
	switch (actions.type) {
		case GET_BID_PRODUCT:
			return {
				...state,
				bidProduct: actions.payload.data,
			}
		case SET_ADVER_TISEMENT:
			return {
				...state,
				isClosePopupAdvertisement: actions.data,
			}
		case TYPE_INTRO_TOUR:
			  return {
				...state,
				typeIntroTour: actions.data,
			  };
		case GET_UP_NEXT_PRODUCT:
			return {
				...state,
				upNextProduct: actions.payload.data,
			}
		case GET_BANNER_HOME:
			return {
				...state,
				banner: actions.payload.data,
			}
		case GET_TOTAL_USER_BID:
			return {
				...state,
				totalUserBid: actions.payload.data,
			}
    case SET_SHWE_HOURS_ICON:
      return {
        ...state,
        shweHoursIconData: actions.data,
      }
		default:
			return state
	}
}
export default reducerHome
